import { Controller, Get, Post } from '@nestjs/common';
import { StatesService } from './states.service';
import { ApiTags } from '@nestjs/swagger';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from 'libs/shared-utils/error-messages/src/lib/global-errors/application-exception-handler';

@ApiTags('states')
@Controller('states')
export class StatesController {
 

  constructor(
    private statesService: StatesService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
}

  @Post   ('/getAllStates')
  async getAllStates(): Promise<CommonResponse> {
      try {
          return this.statesService.getAllStates();
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);

      }
  }
}
